import adapter from '../adapter-blog-post';
import { buildBlogPostSchema } from './utils';
var schemaType = adapter.SchemaTypes.BLOG_POST_NEWS_ARTICLE;
var type = 'NewsArticle';
export default buildBlogPostSchema({ schemaType: schemaType, type: type });
